import {Card} from '@web-libs/ui/ui-components/card/card';
import {Column} from '@web-libs/ui/layout-components/column';
import {Logo} from '@web-libs/features/branding/logo/ui/logo';
import {Headline} from '@web-libs/ui/ui-components/typo/headline';
import {Color, getCssVar} from '@web-libs/features/colors/application/colors';
import {Text} from '@web-libs/ui/ui-components/typo/text';
import {ReactNode} from 'react';

export type AuthPageCardProps = {
    headline: string,
    description?: string,
    form: ReactNode,
    bottomNavigation?: ReactNode
    color?: Color
}

const contrastColors: Partial<{[key in Color] : Color}> = {
    light: "dark",
    dark: "light",
    primary: "onPrimary"
}

export const AuthPageCard = (props: AuthPageCardProps) => {
    const _color: Color = props.color ? props.color : "light";
    const unobstrusiveColor: Color = _color === "light" ? "unobtrusive" : "light";
    const contrastColor: Color = contrastColors[_color] ?? "dark";

    return (
        <Card style={{flexGrow: 1}} color={_color} spaceBetween alignCenter fullHeight>
            <Column alignCenter>
                <Logo withBackground/>
                <Headline style={{marginTop: 32, color: getCssVar(contrastColor)}} size={'md'}>{props.headline}</Headline>
                {props.description && <Text style={{marginTop: 16}} size={'sm'}>{props.description}</Text>}
            </Column>
            <div style={{maxWidth: 500, width: '100%', display: 'flex', justifyContent: 'center', marginTop: 16}}>
                {props.form}
            </div>
            <div style={{marginTop: 16}}>
                {props.bottomNavigation ? props.bottomNavigation : <div></div>}
            </div>
        </Card>
    );
};
